import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { ICircle } from 'daily-dose-common'
import circleDefaultImage from '../../assets/images/circle.png'
import { CardActionArea, Grid, IconButton } from '@material-ui/core'
import { GroupAddIcon } from '../../assets/icons'

const useStyles = makeStyles({
  media: {
    height: 250,
  },
  mainButtons: {
    fontWeight: 550,
  },
  // TODO: Discuss with Abraham. Not sure about this
  card: {
    boxShadow: '10px 10px 13px -2px rgba(0,0,0,0.19)',
  },
})

interface IMyCircleCardItemProps {
  circle: ICircle
  onGoToAddDose: () => void
  onGoToAddMember: () => void
  onGoToDailyDose: () => void
  onGoToMyCircleDetail: () => void
  onGoToPastDoses: () => void
}

export const MyCircleCardItem = ({
  circle,
  onGoToAddDose,
  onGoToAddMember,
  onGoToDailyDose,
  onGoToMyCircleDetail,
  onGoToPastDoses,
}: IMyCircleCardItemProps) => {
  const classes = useStyles()

  return (
    <Card variant="elevation">
      <CardActionArea onClick={onGoToMyCircleDetail}>
        <CardMedia
          className={classes.media}
          image={circle.photoURL || circleDefaultImage}
          title={circle.description}
        />
      </CardActionArea>
      <CardContent>
        <Grid container direction="row" spacing={1}>
          <Grid container item justify="space-between" alignItems="center">
            <Grid item xs={10}>
              <CardActionArea onClick={onGoToMyCircleDetail}>
                <Typography variant="h5" component="h2">
                  {circle.name}
                </Typography>
              </CardActionArea>
            </Grid>
            <Grid container item xs={2} direction="row" justify="flex-end">
              {/* <Grid item> */}
              <IconButton
                aria-label="add member"
                onClick={onGoToAddMember}
                color="primary"
                size="small"
                edge="end"
              >
                <GroupAddIcon fontSize="large" />
              </IconButton>
              {/* </Grid> */}
              {/* <Grid item>
                <IconButton
                  aria-label="circle details"
                  onClick={onGoToMyCircleDetail}
                  color="primary"
                  size="medium"
                  edge="end"
                >
                  <SettingsIcon />
                </IconButton>
              </Grid> */}
            </Grid>
          </Grid>
          {!!circle.description && (
            <Grid item>
              <Typography variant="body2" color="textSecondary" component="p">
                {circle.description}
              </Typography>
            </Grid>
          )}
          <Grid item>
            <Typography variant="body2" color="textSecondary" component="p">
              Members: <b>{circle.membersUsernames.join(', ')}</b>
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions>
        <Button
          size="small"
          color="primary"
          className={classes.mainButtons}
          onClick={onGoToDailyDose}
        >
          {`Today's dose`}
        </Button>
        <Button
          size="small"
          color="primary"
          className={classes.mainButtons}
          onClick={onGoToAddDose}
        >
          Add Dose
        </Button>
        <Button
          size="small"
          color="primary"
          className={classes.mainButtons}
          onClick={onGoToPastDoses}
        >
          Past Doses
        </Button>
      </CardActions>
    </Card>
  )
}
